var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ui-progress', { 'ui-progress_rounded': _vm.rounded }]},[_c('div',{staticClass:"ui-progress__line",style:(_vm.background)},[_c('div',{staticClass:"ui-progress__now",style:(_vm.lineStyles)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }